import React, { useRef, useState, useEffect, useCallback } from "react";
import "./JourneyFrames.css";

const journeyFrames = [
  {
    location: "Vietnam",
    alt: "Vietnam trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/vietnam%202.jpeg?auto=format&q=30&w=600",
  },
  {
    location: "Dubai",
    alt: "Dubai trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/dubai%20re%2001.jpeg?updatedAt=1711452484035&auto=format&q=30&w=600",
  },
  {
    location: "Bhutan",
    alt: "Bhutan trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/bhutan%204.jpeg?auto=format&q=30&w=600",
  },
  {
    location: "Kerala",
    alt: "Kerala trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/kerala-trips-1.jpeg?auto=format&q=30&w=600",
  },
  {
    location: "Meghalaya",
    alt: "Meghalaya trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/meghalaya%201.jpeg?updatedAt=1711451040355&auto=format&q=30&w=600",
  },
  {
    location: "Uttarakhand",
    alt: "Uttarakhand trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/uttarakhand-re-2.jpeg?updatedAt=1711452678546&auto=format&q=30&w=600",
  },
  {
    location: "Rajasthan",
    alt: "Rajasthan trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/rajasthan-gallery-image-4.jpeg?auto=format&q=30&w=600",
  },
  {
    location: "Sikkim",
    alt: "Sikkim trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/sikkim-trips-5.jpeg?updatedAt=1711451159482&auto=format&q=30&w=600",
  },
  {
    location: "Ladakh",
    alt: "Ladakh trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/ladakh-re.jpeg?updatedAt=1711452735926&auto=format&q=30&w=600",
  },
  {
    location: "Himachal",
    alt: "Himachal trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/himachal%20re.jpeg?updatedAt=1711452816194&auto=format&q=30&w=600",
  },
  {
    location: "Spiti",
    alt: "Spiti trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/spiti-re.jpeg?updatedAt=1711452870760&auto=format&q=30&w=600",
  },
  {
    location: "Thailand",
    alt: "Thailand trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/thailand-gallery%203.jpeg?updatedAt=1711450980744&auto=format&q=30&w=600",
  },
  {
    location: "Vietnam",
    alt: "Vietnam trip 2",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/vietnam%208.jpeg?updatedAt=1711450687700&auto=format&q=30&w=600",
  },
  {
    location: "Bhutan",
    alt: "Bhutan trip 2",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/bhutan%207.jpeg?updatedAt=1711450931114&auto=format&q=30&w=600",
  },
  {
    location: "Kashmir",
    alt: "Kashmir trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/kashmir%206.jpeg?updatedAt=1711451082247&auto=format&q=30&w=600",
  },
  {
    location: "Andaman",
    alt: "Andaman trip",
    image:
      "https://wanderon-images.gumlet.io/new-homepage-data/Gallery/andaman%20re.jpeg?updatedAt=1711452917435&auto=format&q=30&w=600",
  },
];

const PinIcon = () => (
  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M8 1.33a4.67 4.67 0 0 0-4.67 4.67c0 3.5 4.67 8.67 4.67 8.67s4.67-5.17 4.67-8.67A4.67 4.67 0 0 0 8 1.33Zm0 6.34a1.67 1.67 0 1 1 0-3.34 1.67 1.67 0 0 1 0 3.34Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

const JourneyFrames = () => {
  const trackRef = useRef(null);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(true);

  const updateScrollState = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    setCanScrollPrev(track.scrollLeft > 4);
    setCanScrollNext(
      track.scrollLeft + track.clientWidth < track.scrollWidth - 4
    );
  }, []);

  useEffect(() => {
    updateScrollState();
    const track = trackRef.current;
    if (!track) return;
    track.addEventListener("scroll", updateScrollState, { passive: true });
    window.addEventListener("resize", updateScrollState);
    return () => {
      track.removeEventListener("scroll", updateScrollState);
      window.removeEventListener("resize", updateScrollState);
    };
  }, [updateScrollState]);

  const scrollByAmount = (direction) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector(".jf-card");
    const gap = 8;
    const cardWidth = card ? card.offsetWidth + gap : 278;
    track.scrollBy({ left: direction * cardWidth, behavior: "smooth" });
  };

  return (
    <section className="jf-section">
      <header className="jf-header">
        <h2 className="jf-title">Journey in Frames</h2>
        <span aria-hidden="true" className="jf-underline" />
        <p className="jf-subtitle">Pictures Perfect Moments</p>
      </header>

      <div className="jf-wrapper">
        <div aria-hidden="true" className="jf-curve jf-curve-top" />

        <button
          type="button"
          aria-label="Previous photos"
          className="jf-nav jf-nav-prev"
          onClick={() => scrollByAmount(-1)}
          disabled={!canScrollPrev}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M10 12L6 8l4-4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="jf-track" ref={trackRef}>
          {journeyFrames.map((frame, index) => (
            <div className="jf-card" key={frame.location + index}>
              <img
                src={frame.image}
                alt={frame.alt}
                loading="lazy"
                decoding="async"
                className="jf-image"
              />
              <div className="jf-tag">
                <span className="jf-tag-icon">
                  <PinIcon />
                </span>
                {frame.location}
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          aria-label="Next photos"
          className="jf-nav jf-nav-next"
          onClick={() => scrollByAmount(1)}
          disabled={!canScrollNext}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M6 4l4 4-4 4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div aria-hidden="true" className="jf-curve jf-curve-bottom" />
      </div>
    </section>
  );
};

export default JourneyFrames;